import memoize from 'memoize-one';

import { GlobalTransitionPreloader } from './GlobalTransitionPreloader';

export const getGlobalTransitionPreloader = memoize(() => {
	return new GlobalTransitionPreloader();
});
